import SectionHeading from "../SectionHeading";
import PricingItem from "./PricingItem";
import { useTranslation } from "react-i18next";

const SecPrices = ({
  
  ClassSec = "features section-padding-0-70",
  ClassSpanTitle,
}) => {
  const { t } = useTranslation();
const products = [
  {
      "Round":t('productsTitle1'),
      "img":"https://assets5.lottiefiles.com/packages/lf20_k0qv8hhf.json",
      "link":"https://invoices.itstcc.com/"
  },
  {
    "Round":t('productsTitle2'),
    "img":"https://assets1.lottiefiles.com/packages/lf20_TMRZ23.json",
      "link":"http://onlinestore.com.s3-website-eu-west-1.amazonaws.com/e-commerce"

  },
  {
    "Round":t('productsTitle3'),
    "img":"https://assets10.lottiefiles.com/packages/lf20_gwjpwf21.json",
      "link":null

  },
  {        
    "Round":t('productsTitle4'),
    "img":"https://assets9.lottiefiles.com/packages/lf20_hnm1chvh.json",
      "link":null

  }
]
  return (
    <section className={ClassSec} id="products">
      <div className="container">
        <SectionHeading
          title={t('portfolio')}
          text={t('products')}
          ClassSpanTitle={ClassSpanTitle}
        />
        <div className="row align-items-center">
          {products &&
            products.map((item, key) => (
              <PricingItem
                key={key}
                Round={item.Round}
                img={item.img}
                link={item.link}
              />
            ))}
        </div>
      </div>
    </section>
  );
};

export default SecPrices;
